const MIN_DIRECTION = -180;
const MAX_DIRECTION = 180;
const sliderWidth = '8rem';

const effects = [
  { type: '', label: 'None', labelStyle: {} },
  {
    type: 'shadow',
    label: 'Shadow',
    labelStyle: { textShadow: '2px 2px 1px rgba(0, 0, 0, 0.3)' },
    trackingProperty: 'Shadow',
    defaultValues: {
      blur: 50,
      offset: 50,
      direction: 120,
      transparency: 30,
      primaryColor: '#000000',
    },
  },
  {
    type: 'outline',
    label: 'Outline',
    labelStyle: {
      WebkitTextStroke: `1px rgb(0 0 0)`,
      WebkitTextFillColor: 'transparent',
      fontFamily: 'arial',
    },
    isSameAsTextColor: true,
    defaultValues: { thickness: 30 },
  },
  {
    type: 'glow',
    label: 'Glow',
    labelStyle: { textShadow: '0px 0px 6px rgba(0, 0, 0, 0.47)' },
    defaultValues: { intensity: 100 },
    isSameAsTextColor: true,
  },
  {
    type: 'offset',
    label: 'Offset',
    labelStyle: { textShadow: '2px 2px 0px rgba(0, 0, 0, 0.25)' },
    defaultValues: {
      blur: 0,
      offset: 50,
      direction: 120,
      transparency: 25,
    },
    isSameAsTextColor: true,
  },
  {
    type: 'repeat',
    label: 'Repeat',
    labelStyle: {
      textShadow: 'rgba(43, 43, 53, 0.5) 1.55527px 1.04905px 0px, rgba(43, 43, 53, 0.3) 3.11055px 2.09809px 0px',
      color: 'black',
    },
    defaultValues: { offset: 100, direction: 120 },
    isSameAsTextColor: true,
  },
];

export { effects, MAX_DIRECTION, MIN_DIRECTION, sliderWidth };
